import React from "react";
import styled, { css } from "styled-components";

const StyledButton = styled.button`
  border-radius: 0.143em;
  border: none;
  background-color: #f6be41;
  outline: none;
  font-size: 0.857em;
  font-family: Lato;
  font-weight: 700;
  color: #2d3639;
  padding: 0.371em 0.571em;
  height: 2.143em;
  cursor: pointer;
  ${({ bStyle }) =>
    bStyle === "outline-orange" &&
    css`
      color: #f6be41;
      border: 0.071em solid #f6be41;
      background-color: transparent;
    `}
  ${({ disabled }) =>
    disabled &&
    css`
      color: #b8c4c9;
      border: 0.071em solid #b8c4c9;
      background-color: #eceff1;
    `}
`;

const Button = ({ title, ...props }) => (
  <StyledButton {...props}>{title}</StyledButton>
);

export default Button;
